import React from "react";

import FOTO_BIO from "../images/BioPage/FOTO_BIO.jpeg";

const BioPage = () => {
  return (
    <>
      <div className="bio-page">
        <div className="photo-bio-left">
          <img src={FOTO_BIO} alt="Description 1" />
        </div>

        <div className="description-bio-right">
          <p style={{ fontWeight: "bold", fontSize: "32px" }}> Milly Fanzaga</p>
          <p style={{ fontWeight: "bold", fontSize: "26px" }}>
            {" "}
            Batterista professionista, insegnante nonché autore.
          </p>
          <p style={{ fontSize: "24px" }}>
            Nella sua ormai trentennale carriera ha tenuto concerti e seminari
            su tutto il territorio nazionale, con varie esperienze anche a
            livello internazionale; diverse sono state anche le apparizioni
            televisive e le collaborazioni a livello di studio che spaziano in
            ambiti musicali quali: rock, pop, progressive, funk e musica jazz.
          </p>
          <p style={{ fontSize: "24px" }}>
            {" "}
            Nel corso degli anni, nella sua intensa attività didattica, ha
            organizzato eventi culturali, incontri e clinics con i maggiori
            esponenti della scena musicale mondiale.
          </p>
        </div>
      </div>
    </>
  );
};

export default BioPage;
